import React, { Suspense, lazy } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
// Maintain order of importing root pcss before refresh component
// import './static/scss/mobile/landing-page.scss';
import './ajio-styles/root.pcss';
import LoaderRefresh from './refresh/atoms/Loader';
import SplashScreen from './refresh/pages/NavigationMsite/SplashScreen';
// import { LandingPageWF } from './components/mobile/pwa/LandingPageWF';
import { getLuxeFlags } from './Flags/selectors';
import { getCurrentStore } from './refresh/selectors/metaData';
// import AppFleek from './fleek';
const AppFleek = React.lazy(() => import('./fleek'));
import {
  getShowRevampedNavigation,
  getNavigationConfigs,
  getChildStores,
  getMasterFlagFleek,
  getEnableAjioMemberShipProgram
} from './refresh/selectors/featureFlagsSelector';
import { checkIsChildStore } from './utils/NavigationRevamp';
import { FLEEK_STORE } from './constants/constant';
import { revampedNavigation, interstitialParam } from './refresh/constants/navigation.constants';
import { isCMSPreview } from './utils/NavigationRevamp';
import { FLEEK_STORE_NAME } from './fleek/utils/constants';
import Loader from './components/common/Loader';
// import FleekNotFoundPage from './fleek/pages/FleekNotFound'
const FleekNotFoundPage = React.lazy(() => import('./fleek/pages/FleekNotFound'));
// import NotFoundPage from './components/mobile/NotFoundPage';
import SubscriptionLandingPageShimmer from './refresh/pages/SubscriptionLandingPage/SubscriptionLandingPageShimmer';

const NewLandingPageLazy = lazy(() => import('./refresh/pages/LandingPage/LandingPage'));
// const OldLandingPageLazy = lazy(() => import('./OldLandingPage'));
const LuxeLandingPageLazy = lazy(() => import('./refresh/pages/LandingPage/Luxe'));
const SubscriptionPageLazy = lazy(() => import('./refresh/pages/SubscriptionLandingPage'));
const ViewMoreEmiPlansLazy = lazy(() => import('./refresh/pages/ViewMoreEmiPlans'));

const NotFoundPage = lazy(() => import('./components/mobile/NotFoundPage'));

const mapStateToProps = state => {
  const { flags = {} } = state;
  return {
    luxeFlags: getLuxeFlags(flags),
    name: getCurrentStore(state),
    showRevampedNavigation: getShowRevampedNavigation(state) === 'ON',
    getNavigationConfigs: getNavigationConfigs(state),
    childStores: getChildStores(state),
    masterFleekFlag: getMasterFlagFleek(state),
    isNewNavEnabled: state?.navigation?.newNavigationEnabled,
    enableSubscription: getEnableAjioMemberShipProgram(flags, state)
  };
};

// const OldLandingPage = () => {
//   return (
//     <Suspense fallback={<LandingPageWF />}>
//       <OldLandingPageLazy />
//     </Suspense>
//   );
// };

const NewLandingPage = ({
  showRevampedNavigation = false,
  isChildStore = false,
  fromHomepage = false,
  fromInterstitial = false
}) => {
  return (
    <Suspense
      fallback={
        showRevampedNavigation &&
        !isChildStore &&
        ((fromHomepage && fromInterstitial) || isCMSPreview()) ? (
          <SplashScreen fromHomepage={fromHomepage} />
        ) : (
          <LoaderRefresh />
        )
      }
    >
      <NewLandingPageLazy
        fromHomepage={fromHomepage}
        fromInterstitial={fromInterstitial}
        isChildStore={isChildStore}
      />
    </Suspense>
  );
};

const LuxeLandingPage = ({
  showRevampedNavigation = false,
  fromHomepage = false,
  fromInterstitial = false
}) => {
  return (
    <Suspense
      fallback={
        showRevampedNavigation && ((fromHomepage && fromInterstitial) || isCMSPreview()) ? (
          <SplashScreen fromHomepage={fromHomepage} />
        ) : (
          <LoaderRefresh />
        )
      }
    >
      <LuxeLandingPageLazy fromHomepage={fromHomepage} fromInterstitial={fromInterstitial} />
    </Suspense>
  );
};

const SubscriptionPage = () => {
  return (
    <Suspense fallback={<SubscriptionLandingPageShimmer />}>
      <SubscriptionPageLazy />
    </Suspense>
  );
};

const ViewMoreEmiPlans = () => {
  return (
    <Suspense fallback={<LoaderRefresh />}>
      <ViewMoreEmiPlansLazy />
    </Suspense>
  );
};

const routes = props => {
  const {
    luxeFlags,
    name,
    showRevampedNavigation,
    getNavigationConfigs,
    childStores,
    isNewNavEnabled = false,
    enableSubscription = false
  } = props;
  const { isThemeEnable } = luxeFlags;
  const isChildStore = checkIsChildStore(name, childStores);
  const isRevampedNavigationEnable = showRevampedNavigation && isNewNavEnabled;

  const { location = {} } = window;
  let pathname = location?.pathname;
  const searchParams = location?.search;
  const fromHomepage = /^\/$/.test(pathname);
  const fromInterstitial = searchParams?.includes(interstitialParam);

  const customProps = {
    fromInterstitial
  };

  console.log('Master flags fleek', props.masterFleekFlag);

  const RootRoute = ({ name, isThemeEnable }) => {
    if (!enableSubscription && pathname === '/membership') {
      return (
        <Suspense fallback={<div />}>
          <NotFoundPage />
        </Suspense>
      );
    }

    if (name === FLEEK_STORE && props.masterFleekFlag === 'ON') {
      return (
        <Suspense fallback={<Loader name="Fleek-success" />}>
          <Route path="/" render={props => <AppFleek {...props} {...customProps} />} />
          <Route path="/membership" exact>
            <SubscriptionPage />
          </Route>
        </Suspense>
      );
    } else if (name === FLEEK_STORE) {
      return (
        <Suspense fallback={<Loader name="Fleek-not-found" />}>
          <FleekNotFoundPage />
        </Suspense>
      );
    } else {
      let comp =
        isThemeEnable === 'ON' && name === 'luxe' ? (
          <LuxeLandingPage
            showRevampedNavigation={isRevampedNavigationEnable}
            fromHomepage={fromHomepage}
            fromInterstitial={fromInterstitial}
          />
        ) : (
          <NewLandingPage
            showRevampedNavigation={isRevampedNavigationEnable}
            isChildStore={isChildStore}
            fromHomepage={fromHomepage}
            fromInterstitial={fromInterstitial}
          />
        );
      return (
        <>
          <Route path="/" exact>
            {comp}
          </Route>
          <Route path="/shop/:catstr">{comp}</Route>
          <Route path="/membership" exact>
            <SubscriptionPage />
          </Route>
          <Route path="/viewmore-emi-plans" exact>
            <ViewMoreEmiPlans />
          </Route>
        </>
      );
    }
  };

  return (
    <Router>
      <Switch>
        <RootRoute name={name} isThemeEnable={isThemeEnable} />
      </Switch>
    </Router>
  );
};

export default connect(mapStateToProps)(routes);
